import React from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import {arrayToBounds} from "../../lib/google-maps";
import ImageOverlay from "../ImageOverlay";

class MapOverlayImage extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  render() {
    const {overlay} = this.props.floor;
    const latLngBounds = arrayToBounds(this.props.floor.geo.coordinates);
    return (
      <div>
        <ImageOverlay
          heading={overlay.heading}
          opacity={overlay.opacity}
          image={overlay.image.path}
          bounds={latLngBounds}
          map={window.MP_MAPEDIT_REF || window.MP_MAP_REF}
        />
      </div>
    );
  }
}

MapOverlayImage.propTypes = {
  floor: PropTypes.object.isRequired
};

export default MapOverlayImage;



// WEBPACK FOOTER //
// ./src/components/MapOverlayImage/index.jsx